import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'header.links.content': {
    id: 'header.links.content',
    defaultMessage: 'Content',
    description: 'Label for Content menu trigger',
  },
  'header.links.settings': {
    id: 'header.links.settings',
    defaultMessage: 'Settings',
    description: 'Label for Settings menu trigger',
  },
  'header.links.tools': {
    id: 'header.links.content.tools',
    defaultMessage: 'Tools',
    description: 'Label for Tools menu trigger',
  },
  'header.links.outline': {
    id: 'header.links.outline',
    defaultMessage: 'Outline',
    description: 'Link to Studio Outline page',
  },
  'header.links.updates': {
    id: 'header.links.updates',
    defaultMessage: 'Updates',
    description: 'Link to Studio Updates page',
  },
  'header.links.pages': {
    id: 'header.links.pages',
    defaultMessage: 'Pages & Resources',
    description: 'Link to Studio Pages page',
  },
  'header.links.filesAndUploads': {
    id: 'header.links.filesAndUploads',
    defaultMessage: 'Files',
    description: 'Link to Studio Files page',
  },
  'header.links.textbooks': {
    id: 'header.links.textbooks',
    defaultMessage: 'Textbooks',
    description: 'Link to Studio Textbooks page',
  },
  'header.links.videoUploads': {
    id: 'header.links.videoUploads',
    defaultMessage: 'Videos',
    description: 'Link to Studio Video Uploads page',
  },
  'header.links.scheduleAndDetails': {
    id: 'header.links.scheduleAndDetails',
    defaultMessage: 'Schedule & Details',
    description: 'Link to Studio Schedule & Details page',
  },
  'header.links.grading': {
    id: 'header.links.grading',
    defaultMessage: 'Grading',
    description: 'Link to Studio Grading page',
  },
  'header.links.courseTeam': {
    id: 'header.links.courseTeam',
    defaultMessage: 'Course Team',
    description: 'Link to Studio Course Team page',
  },
  'header.links.groupConfigurations': {
    id: 'header.links.groupConfigurations',
    defaultMessage: 'Group Configurations',
    description: 'Link to Studio Group Configurations page',
  },
  'header.links.proctoredExamSettings': {
    id: 'header.links.proctoredExamSettings',
    defaultMessage: 'Proctored Exam Settings',
    description: 'Link to Studio Proctored Exam Settings page',
  },
  'header.links.advancedSettings': {
    id: 'header.links.advancedSettings',
    defaultMessage: 'Advanced Settings',
    description: 'Link to Studio Advanced Settings page',
  },
  'header.links.certificates': {
    id: 'header.links.certificates',
    defaultMessage: 'Certificates',
    description: 'Link to Studio Certificates page',
  },
  'header.links.publisher': {
    id: 'header.links.publisher',
    defaultMessage: 'Publisher',
    description: 'Link to Publisher',
  },
  'header.links.import': {
    id: 'header.links.import',
    defaultMessage: 'Import',
    description: 'Link to Studio Import page',
  },
  'header.links.exportCourse': {
    id: 'header.links.exportCourse',
    defaultMessage: 'Export Course',
    description: 'Link to Studio Export page',
  },
  'header.links.exportTags': {
    id: 'header.links.exportTags',
    defaultMessage: 'Export Tags',
    description: 'Download course content tags as CSV',
  },
  'header.links.checklists': {
    id: 'header.links.checklists',
    defaultMessage: 'Checklists',
    description: 'Link to Studio Checklists page',
  },
  'header.user.menu.studio': {
    id: 'header.user.menu.studio',
    defaultMessage: 'Studio Home',
    description: 'Link to Studio Home',
  },
  'header.user.menu.maintenance': {
    id: 'header.user.menu.maintenance',
    defaultMessage: 'Maintenance',
    description: 'Link to the Studio maintenance page',
  },
  'header.user.menu.logout': {
    id: 'header.user.menu.logout',
    defaultMessage: 'Logout',
    description: 'Logout link',
  },
  'header.label.account.menu': {
    id: 'header.label.account.menu',
    defaultMessage: 'Account Menu',
    description: 'The aria label for the account menu trigger',
  },
  'header.label.account.menu.for': {
    id: 'header.label.account.menu.for',
    defaultMessage: 'Account menu for {username}',
    description: 'The aria label for the account menu trigger when the username is displayed in it',
  },
  'header.label.main.nav': {
    id: 'header.label.main.nav',
    defaultMessage: 'Main',
    description: 'The aria label for the main menu nav',
  },
  'header.label.main.menu': {
    id: 'header.label.main.menu',
    defaultMessage: 'Main Menu',
    description: 'The aria label for the main menu trigger',
  },
  'header.label.main.header': {
    id: 'header.label.main.header',
    defaultMessage: 'Main',
    description: 'The aria label for the main header',
  },
  'header.label.secondary.nav': {
    id: 'header.label.secondary.nav',
    defaultMessage: 'Secondary',
    description: 'The aria label for the secondary nav',
  },
  'header.label.courseOutline': {
    id: 'header.label.courseOutline',
    defaultMessage: 'Back to course outline in Studio',
    description: 'The aria label for the link back to the Studio Course Outline',
  },
});

export default messages;
